import {each} from "lodash";
import {Dispatch} from "redux";
import {addAlert, AlertType} from "@web2/ap-alerts";
import {apiLink} from "@web2/ap-api-routes";
import {catch400, postRequest} from "@web2/ap-request";
import {apAppLink} from "@web2/ap-routes";

import {apHistory} from "../../app/utils/history";

interface ChangePasswordRequest extends Record<string, unknown> {
    uid: string;
    token: string;
    new_password: string;
    re_new_password: string;
}

const confirmPasswordSuccessText = "Hasło zostało zmienione!";
const confirmPasswordErrorText = "Błąd podczas próby zmiany hasła: ";

export const postNewPassword = (requestData: ChangePasswordRequest) => (dispatch: Dispatch) => {
    const confirmPasswordUrl = apiLink.account.passwordResetConfirm({});
    return postRequest({}, confirmPasswordUrl(null), requestData)
        .then((json: void) => {
            dispatch(addAlert({type: AlertType.SUCCESS, text: confirmPasswordSuccessText}, 5000));
            apHistory.push(apAppLink.login());

            return json;
        })
        .catch(
            catch400((responseError) => {
                if (responseError.appError?.nonFieldErrors) {
                    each(responseError.appError.nonFieldErrors, (message: string) => {
                        dispatch(addAlert({type: AlertType.ERROR, text: confirmPasswordErrorText + message}));
                    });
                }
            })
        );
};
